export function isDebug(): boolean {
  try {
    const qs = new URLSearchParams(window.location.search);
    if (qs.get("dbg") === "1") return true;
  } catch {}

  // Vite exposes boolean-like strings
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  if (import.meta.env?.VITE_DEBUG_ROADMAP === "true") return true;

  try {
    if (localStorage.getItem("DEBUG_ROADMAP") === "true") return true;
  } catch {}

  return false;
}

export const dbg = {
  log: (...args: any[]) => isDebug() && console.log("[RoadmapDbg]", ...args),
  warn: (...args: any[]) => isDebug() && console.warn("[RoadmapDbg]", ...args),
  error: (...args: any[]) =>
    isDebug() && console.error("[RoadmapDbg]", ...args),
  table: (data: any) =>
    isDebug() &&
    (Array.isArray(data) ? console.table(data) : console.log(data)),
  checkpoint: (label: string, extra?: any) =>
    isDebug() &&
    console.log(`%c[RoadmapDbg] ${label}`, "color:#0a0", extra ?? ""),
  summarize(value: any): string {
    if (Array.isArray(value)) return `Array(len=${value.length})`;
    if (value && typeof value === "object")
      return `Object(keys=${Object.keys(value).length})`;
    return String(value);
  },
};
